<template>
  <div id="extra-component-form-validation-demo">
    <List></List>
  </div>
</template>
<script>

import List from "./ReportData.vue"

export default {
  components: {
    List
  }
}
</script>
